import type { TokenStorage } from '@dt-pm/core';

const ACCESS_TOKEN_KEY = 'dtpm.accessToken';
const REFRESH_TOKEN_KEY = 'dtpm.refreshToken';

/**
 * Implementacao Web do TokenStorage.
 * No React Native este arquivo vira uma versao com AsyncStorage/Keychain,
 * mantendo a mesma interface consumida pelo core.
 */
export const webTokenStorage: TokenStorage = {
  getAccessToken: () => localStorage.getItem(ACCESS_TOKEN_KEY),
  getRefreshToken: () => localStorage.getItem(REFRESH_TOKEN_KEY),
  setTokens: ({ accessToken, refreshToken }) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },
  clear: () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },
};
